
export const SOFTLINE_PERMISSION_ESL = 'SOFTAPPS.ESL_LINK';
